// extracted by mini-css-extract-plugin
export default {"quiz_card":"trendingQuizs_quiz_card__Li4cQ","trendingQuiz_title":"trendingQuizs_trendingQuiz_title__cfo-n","quizCrads_container":"trendingQuizs_quizCrads_container__ini-A"};